import { render, staticRenderFns } from "./AppNavSide.vue?vue&type=template&id=c5c7781c&"
import script from "./AppNavSide.vue?vue&type=script&lang=js&"
export * from "./AppNavSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports